import LanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/LanguagePack";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import ProgressGameModel from "../../save-game/model/ProgressGameModel";
import DashboardCumulativeData from "../model/DashboardCumulativeData";
import DashboardData from "../model/DashboardData";
import DashboardSingleData from "../model/DashboardSingeData";
import DashboardCumulativeDataMediator from "../view/DashboardCumulativeDataMediator";
import DashboardNumberChartMediator from "../view/DashboardNumberChartMediator";
import DashboardNumberChartFactory from "./DashboardNumberChartFactory";


export default class DashboardCumulativeDataFactory {
    /**
     * @param {MediatorManager} mediatorManager 
     * @param {DashboardData} dashboardData 
     * @param {LanguagePack} languagePack 
     * @param {ProgressGameModel} progressGameModel 
     */
    constructor(mediatorManager, dashboardData, languagePack, progressGameModel) {
        this._mediatorManager = mediatorManager;
        this._dashboardData = dashboardData;
        this._languagePack = languagePack;
        this._progressGameModel = progressGameModel;
    }

    createCumulativeData(container, localisedKey, type) {

        /** @type {DashboardCumulativeDataMediator} */
        let numberCumulativeData = this._mediatorManager.createMediator(container, SkinKeyRegistry.DASHBOARD_CUMULATIVE_DATA_SKIN);

        const path = this._progressGameModel.path;

        var dashboardSingleData = new DashboardCumulativeData(
            this._languagePack.getText(localisedKey),
            this._dashboardData.getCumulativeData(type, path),
            this._dashboardData.getBestCumulativeData(type),
            this._dashboardData.getWorstCumulativeData(type)
        );

        numberCumulativeData.setData(dashboardSingleData);
        return numberCumulativeData;
    }
}
DashboardNumberChartFactory.EPI_DATA = "epidata";
DashboardNumberChartFactory.HEALTH_SYSTEMS = "health-systems";